import React, { useState } from 'react';
import parentloginStyle from './ParentsLoginPage.module.css'
import logo from '../../../assets/images/brandlogo.png'
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { FaUserLarge } from "react-icons/fa6";
import { FaLock } from "react-icons/fa6";
import { Link } from 'react-router-dom';
require('typeface-poppins')

export default function ParentsLoginPage() {

    // Eye	
    const [isPasswordVisible, setPasswordVisible] = useState(false);
    const togglePasswordVisibility = () => {
        setPasswordVisible(!isPasswordVisible);
    };

    return (
        <>
            <div className={parentloginStyle.parentscationMain}>
                <div className="container h-100">
                    <div className="row justify-content-center h-100 align-items-center">
                        <div className="col-md-6">
                            <div className={parentloginStyle.parentscationContent}>
                                <div className="row no-gutters">
                                    <div className="col-xl-12">
                                        <div className={parentloginStyle.parentsForm}>
                                            <div className="text-center mb-3">
                                                <a href="#" className={parentloginStyle.parentsbrandLink}>
                                                    <img src={logo} alt="BrandLogo" />
                                                    <div className={parentloginStyle.parentsbrandInfo}>
                                                        <span> AuthorMeet </span>
                                                        <small> Powered by: &nbsp; Bookworm Central </small>
                                                    </div>
                                                </a>
                                            </div>
                                            <h4 className={parentloginStyle.parentsbrandTitle}> Parents Sign-in </h4>
                                            <form>
                                                <div className={`${parentloginStyle.parentsinputIconboxes} input-group mb-4`}>
                                                    <span className={`${parentloginStyle.parentsinputIcon} input-group-text`}>
                                                        <FaUserLarge className={parentloginStyle.parentsprimaryColor} />
                                                    </span>
                                                    <input type="email" className={`${parentloginStyle.parentsinputFeild} form-control`} placeholder="Email Address" required />
                                                </div>
                                                <div className={`${parentloginStyle.parentsinputIconboxes} input-group mb-3`}>
                                                    <span className={`${parentloginStyle.parentsinputIcon} input-group-text`}>
                                                        <FaLock className={parentloginStyle.parentsprimaryColor} />
                                                    </span>
                                                    <input type={isPasswordVisible ? "text" : "password"} className={`${parentloginStyle.parentsinputFeild} form-control`} placeholder="Password" required />
                                                    <div className={parentloginStyle.parentstoggleButton} onClick={togglePasswordVisibility}>
                                                        {isPasswordVisible ? <FaEyeSlash className={parentloginStyle.parentseyeIcon} /> : <FaEye className={parentloginStyle.parentseyeIcon} />}
                                                    </div>
                                                </div>
                                                <div className={`${parentloginStyle.parentsforgotPassword} form-group text-center mb-3`}>
                                                    <a href="#"> Forgot Password? </a>
                                                </div>
                                                <div className="form-row d-flex justify-content-between mt-3 mb-3 d-none d-lg-block">
                                                    <div className="form-group">
                                                        <div className="custom-control custom-checkbox ml-1">
                                                            <input type="checkbox" className="custom-control-input me-2" id="" />
                                                            <label className={`${parentloginStyle.parentsrememberMe} custom-control-label`}> Remember me </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`${parentloginStyle.parentsnewAccount} ${parentloginStyle.mobilnewAccount} mb-4 mt-5`}>
                                                    <p className='mb-0'> Create new account? <Link to="/ParentsRegisterPage"> Sign Up </Link></p>
                                                </div>
                                                <div className="text-center">
                                                    <p style={{ color: 'red' }}></p>
                                                    <button type="submit" className={`${parentloginStyle.parentsSigninBtn} btn btn-warning`}>Login</button>
                                                </div>
                                            </form>
                                            <div className={`${parentloginStyle.parentsnewAccount} ${parentloginStyle.desktopnewAccount}`}>
                                                <p className='mb-0'> Create new account?
                                                    <Link to="/ParentsRegisterPage"> Sign Up </Link>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
